<template>
  <div class="picker-field" :class="{ 'picker-field__focus': fieldType != 'combo' }">
    <picker-field v-if="fieldType == 'combo' && !readOnly" :label="label" :display="display" :value="value" :title="title"
      ref="picker" @open="onSearch">
      <div class="list">
        <div class="weui-cells">
          <div class="weui-cell weui-cell_access" v-for="item in items" :key="item.display" @click="select(item)">
            <div class="weui-cell__bd">
              <p>{{ item.display }}</p>
            </div>
            <div class="weui-cell__ft"></div>
          </div>
        </div>
      </div>
    </picker-field>
    <div v-else-if="fieldType == 'date' && !readOnly" class="weui-cell weui-cell_access" @click="selectDate">
      <div class="weui-cell__hd">
        <label for class="weui-label">{{ label }}</label>
      </div>
      <div class="weui-cell__bd" v-format="format">{{ value }}</div>
      <div class="weui-cell__ft">
        <span v-show="!value">请选择</span>
      </div>
    </div>
    <div v-else-if="readOnly" class="weui-form-preview__item weui-cell">
      <label class="weui-form-preview__label">{{ label }}</label>
      <span class="weui-form-preview__value" v-if="fieldType == 'date'" v-format="'yyyy-MM-dd'" key="yyyy-MM-dd">{{value}}</span>
      <span class="weui-form-preview__value" v-else>{{ value }}</span>
    </div>
    <div class="weui-cell weui-cell_access" v-else>
      <div class="weui-cell__hd" v-if="label">
        <label for class="weui-label">{{ label }}</label>
      </div>
      <div class="weui-cell__bd">
        <input class="weui-input" type="text" :value="value" placeholder="请输入..." ref="input" @input="onchange" />
      </div>
    </div>
  </div>
</template>

<script>
import PickerField from "@/components/field/PickerField.vue";


export default {
  props: {
    label: String,
    // display: String,
    value: String,
    title: String,
    caller: String,
    fieldName: String,
    readOnly: {
      type: Boolean,
      default: false
    },
    format: {
      type: String,
      default: "yyyy-MM-dd",
    },
    isFocus: {
      type: Boolean,
      default: false
    },
    url: String,
    autoload: {
      type: Boolean,
      default: false
    }
  },
  components: {
    PickerField
  },
  data() {
    return {
      fieldType: null,
      display: '',
      items: []
    };
  },
  watch: {
    value() {
      var me = this,
        val = me.value;
      // 对于给定初始value值的情况，加载数据并显示出display值
      me.$nextTick(function () {
        if (!me.display && me.autoload) {
          me.$loading({
            url: '/api/document/genericoption/getCombo?fieldName=' + me.fieldName + '&bizType=' + me.caller
          }).then(function (res) {
            if (res.success) {
              if (res.data) {
                var item = res.data.find(d => d.value == val);
                if (item) {
                  me.display = item.display;
                }
              }
            } else {
              me.$weui.topTips(res.message, 2000);
            }
          });
        }
      });
    },
  },
  mounted() {
    this.fieldType = this.$attrs.fieldType
  },
  computed: {
    computedTitle() {
      var me = this;
      return me.title || "选择" + me.label;
    }
  },
  methods: {
    open() {
      var me = this;
      me.showDialog = true;
      me.$nextTick(function () {
        me.$emit("open");
      });
    },
    onchange() {
      var me = this,
        val = me.$refs.input.value
      me.$emit("input", val);
    },
    selectDate() {
      var me = this,
        date = me.value ? new Date(me.value.replace(/-/g, "/")) : new Date(),
        year = date.getFullYear(),
        month = date.getMonth() + 1,
        day = date.getDate();

      me.$weui.datePicker({
        defaultValue: [year, month, day],
        onConfirm: function (r) {
          var date = new Date(r[0].value, r[1].value - 1, r[2].value),
            val = me.dateFormat(date, "yyyy-MM-dd hh:mm:ss");
          me.$emit("input", val);
        },
      });
    },
    select(item) {
      var me = this;
      me.$emit("input", item.value);
      me.display = item.display;
      me.$refs.picker.close();
    },
    onSearch() {
      var me = this;
      me.$loading({
        url: '/api/document/genericoption/getCombo?fieldName=' + me.fieldName + '&bizType=' + me.caller
      }).then(function (res) {
        if (res.success) {
          me.items = res.data;
        } else {
          me.$weui.topTips(res.message, 2000);
        }
      });
    }
  }
};
</script>

<style>
.weui-cells>.picker-field:not(:first-child) {
  position: relative;
}

.weui-cells>.picker-field:not(:first-child):before {
  content: " ";
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  height: 1px;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  border-top: 1px solid var(--weui-FG-3);
  /* color: rgba(0, 0, 0, 0.1); */
  color: var(--weui-FG-3);
  -webkit-transform-origin: 0 0;
  transform-origin: 0 0;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
  left: 16px;
  z-index: 2;
}

.picker-field .weui-picker {
  display: -webkit-box;
  display: -ms-flexbox;
  flex-direction: column
}

.picker-field .weui-picker .weui-half-screen-dialog__hd {
  height: 6em;
}

.picker-field .weui-picker .weui-half-screen-dialog__bd {
  flex: 1;
}

.picker-field__focus .weui-half-screen-dialog {
  max-height: 75%;
}
</style>